// @ts-check

/**
 * @typedef { import('typesafe-i18n').FormattersInitializer<Locales, Formatters> } FormattersInitializer
 * @typedef { import('./i18n-types.js').Locales } Locales
 * @typedef { import('./i18n-types.js').Formatters } Formatters
 */

/**
 * @param { Locales } locale
 * @return { Formatters }
 */
export const initFormatters = (locale) => {
	/** @type { Formatters } */
	const formatters = {
		// add your formatter functions here
	}

	return formatters
}
